<template>
  <div class="box-type01">
    <div class="join-box">
      <div class="entry-txt01 ">개인정보 보호를 위해<br />새로운 비밀번호를 입력해주세요.</div>
      <div class="join-stage-input mgt40">
        <input type="password"
               placeholder="비밀번호" title="비밀번호"
               maxlength="15"
               v-model="mberPswd"/>
        <input type="password"
               placeholder="비밀번호 확인" title="비밀번호 확인"
               maxlength="15"
               v-model="mberPswdCnfm"/>
      </div>
      <div class="entry-txt02 mgt40">8-15자리의 영문/숫자/특수문자를 함께 입력해주세요.</div>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'변경'"
         :color="'purple'"
         @click="btnChng_click"/>
  </div>
</template>

<script setup>
import {ref, defineEmits, defineProps} from "vue";
import {getUtils, getStore} from "@/utils/import";
const {$alert, $valid, $axios, $cmmn} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  mberSn: {
    type: Number,
    required: true
  }
});

const mberPswd = ref('');
const mberPswdCnfm = ref('');

const valid = () => {
  let isValid = true;
  let msg = '';

  const isInputMberPswd = mberPswd.value;
  if (isValid && !isInputMberPswd) {
    isValid = false;
    msg = '비밀번호를 입력해주세요.';
  }

  const isSuitMberPswd = $valid.pswd(mberPswd.value);
  if (isValid && !isSuitMberPswd) {
    isValid = false;
    msg = '비밀번호는 8-15자리의 영문/숫자/특수문자를 함께 입력해주세요.';
  }

  const isInputMberPswdCnfm = mberPswdCnfm.value;
  if (isValid && !isInputMberPswdCnfm) {
    isValid = false;
    msg = '비밀번호 확인을 입력해주세요.';
  }

  const isSameMberPswdCnfm = mberPswd.value == mberPswdCnfm.value;
  if (isValid && !isSameMberPswdCnfm) {
    isValid = false;
    msg = '비밀번호가 일치하지 않습니다. 다시 확인해주세요.';
  }

  return {isValid, msg};
}

const emits = defineEmits(['chng']);
const btnChng_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    await modifyMberPswd({mberSn: props.mberSn, mberPswd: mberPswd.value});
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const modifyMberPswd = async ({mberSn, mberPswd}) => {
  const {data} = await $axios.post('/api/mber/mber-pswd', {mberSn, mberPswd});

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  emits('chng');
}
</script>

<style scoped>

</style>
